import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  subs: {}, // Lightweight items per subType: { [ixSubType]: [ {...} ] }
  subDetails: {} // Deep detailed objects by ixSub: { [ixSub]: { _rm, subType, ... } }
};

const slice = createSlice({
  name: 'subCache',
  initialState,
  reducers: {
    // Upsert basic list items for search
    upsertSubAccounts(state, action) {
      const { ixSubType, subList } = action.payload || {};
      if (!ixSubType || !Array.isArray(subList)) return;

      const existing = state.subs[ixSubType] || [];
      const subById = {};

      existing.forEach(item => {
        const id = item.ixSub ?? item.sub_id;
        if (id != null) subById[id] = item;
      });

      subList.forEach(item => {
        const id = item.ixSub ?? item.sub_id;
        if (id != null) {
          subById[id] = { ...subById[id], ...item };
        }
      });

      state.subs[ixSubType] = Object.values(subById);
    },

    // Save/Update full detailed sub-account objects (including _rm and subType meta)
    setSubDetails(state, action) {
      const detail = action.payload;
      const id = detail?.ixSub ?? detail?.sub_id;
      if (!id) return;

      if (!state.subDetails) {
        state.subDetails = {};
      }

      // Store in deep cache
      state.subDetails[id] = detail;
    },

    clearSubCacheBySubType(state, action) {
      const ixSubType = action.payload;
      if (state.subs[ixSubType]) {
        delete state.subs[ixSubType];
      }
    },

    resetSubCacheState(state) {
      state.subs = {};
      state.subDetails = {};
    }
  }
});

const subCacheReducer = slice.reducer;

export const {
  upsertSubAccounts,
  setSubDetails,
  clearSubCacheBySubType,
  resetSubCacheState
} = slice.actions;

export default subCacheReducer;
